import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon68: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M13.5 0a.5.5 0 0 1 .5.5V3h5.5a.5.5 0 0 1 .5.5v9.48A3.02 3.02 0 0 1 16.98 16H3.019A3.019 3.019 0 0 1 0 12.98V3.5A.5.5 0 0 1 .5 3H6V.5a.5.5 0 0 1 .41-.492L6.5 0h7ZM19 9.225a3.007 3.007 0 0 1-2.02.775H12v1.5a.5.5 0 0 1-.41.492L11.5 12h-3a.5.5 0 0 1-.5-.5V10H3.02a3.005 3.005 0 0 1-2.019-.774L1 12.98A2.02 2.02 0 0 0 3.019 15H16.98A2.02 2.02 0 0 0 19 12.98V9.225ZM11 8H9v3h2V8Zm8-4H1v2.981A2.02 2.02 0 0 0 3.02 9H8V7.5a.5.5 0 0 1 .41-.492L8.5 7h3a.5.5 0 0 1 .5.5V9h4.98a2.019 2.019 0 0 0 2.014-1.869l.006-.15V4Zm-6-3H7v2h6V1Z"
      />
    </Svg>
  )
}
